import { Link } from 'react-router-dom';
import { useRipplingLink } from '@/rippling/util/ripplingXsUtils';

interface RipplingCTALinkProps {
  campaign: string;
  source?: string;
  medium?: string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

/**
 * Reusable component that renders a link to Rippling content
 * based on the configuration from LaunchDarkly.
 *
 * - External links open in new tab with proper security attributes
 * - Internal links use React Router's Link component for SPA navigation
 */
export function RipplingCTALink({ campaign, source, medium, className, onClick, children }: RipplingCTALinkProps) {
  const { url, isExternal } = useRipplingLink({ campaign, source, medium });

  // External link - open in new tab
  if (isExternal) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
        {children}
      </a>
    );
  }

  // Internal link - use React Router Link for SPA navigation
  return (
    <Link to={url} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
